










//接口调用文件
import index from '@/api/index';
//接口配置文件
import { Api } from '@/api/api';
/* 导入router */
import router from '@/router';

export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {
    var that = this;
    that.getResources();
  },
  methods: {
    async getResources() {
      var that = this;
      await index
        .fetchData_post(Api.lanmor.resources, {})
        .finally(() => {})
        .then((ret) => {
          if (ret.ResponseCode == 0) {
            that.$store.commit('setResources', ret.Data);
          } else {
            that.$toast(ret.ResponseContent);
          }
        })
        .catch((err) => {
          that.$toast(err);
        });
    },
  },
};
